import { render, staticRenderFns } from "./template_module.vue?vue&type=template&id=7a7a4fb7&scoped=true"
import script from "./template_module.vue?vue&type=script&lang=js"
export * from "./template_module.vue?vue&type=script&lang=js"
import style0 from "./template_module.vue?vue&type=style&index=0&id=7a7a4fb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7a4fb7",
  null
  
)

export default component.exports